import './App.css';

import { Route, Routes, useLocation } from 'react-router-dom';

import Navbar from './components/navbar';
import Footer from './components/footer';
import {
  Home,
  Tour,
  Complaint,
  Traffic,
  TransSchedule,
  Licensing,
  TourDetails,
  Event,
  EventDetails,
  SearchSchedule,
  TransScheduleDetails,
  NotFound
} from './pages';
import { ROUTES } from './helpers/constants';
import { useEffect } from 'react';

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [pathname]);

  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path={ROUTES.home} element={<Home />} />
        <Route path={ROUTES.event} element={<Event />} />
        <Route path={`${ROUTES.event}/:eventId`} element={<EventDetails />} />
        {/*<Route path={ROUTES.trans_node} element={<TransNode />} />*/}
        <Route path={ROUTES.traffic} element={<Traffic />} />
        <Route path={ROUTES.complaint} element={<Complaint />} />
        <Route path={ROUTES.trans_schedule} element={<TransSchedule />} />
        <Route path={`${ROUTES.trans_schedule}/:transId/rute/:ruteId`} element={<TransScheduleDetails />} />
        <Route path={ROUTES.search_schedule} element={<SearchSchedule />} />
        <Route path={ROUTES.tour} element={<Tour />} />
        <Route path={`${ROUTES.tour}/:tourId`} element={<TourDetails />} />
        <Route path={ROUTES.licensing} element={<Licensing />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
